<template >
    <div class="transfer-shop-dialog">
        <el-dialog :visible.sync="visible" :title="$t('Member.Desc.transfer_store')" left >
            <div class="transfer-shop-title bg-gray mg-10">
                <p class="transfer-shop-title-p">{{ $t('Common.name') }}：{{ client.clientName }}</p>
                <p class="transfer-shop-title-p">{{ $t('Common.phone') }}：{{ client.clientPhone }}</p>
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="100px"
                label-suffix=":">
                    <el-form-item
                        class="transfer-shop-checkbox"
                        :label="$t('Member.Desc.choose_transfer')">
                        <template>
                            <el-checkbox
                                :indeterminate="isIndeterminate"
                                v-model="checkAll"
                                @change="handleCheckAllChange">
                                {{ $t('Course.check_all') }}
                            </el-checkbox>
                            <div style="margin: 5px 0;"></div>
                            <el-checkbox-group
                                v-model="form.contractNums"
                                @change="handleCheckedContractChange">
                                <el-checkbox
                                    v-for="(item, index) in contracts"
                                    :label="item.contractNum"
                                    :key="index">
                                    {{ item.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </template>
                    </el-form-item>
                    <div class="transfer-shop-line"></div>
                    <el-form-item :label="$t('Member.Desc.transfer_to')">
                        <el-select
                            v-model="form.storeId"
                            style="width: 205px;"
                            :placeholder="$t('Common.store_placeholder')">
                            <el-option
                                v-for="(item, index) in stores"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Member.Desc.transfer_fee')" prop="fee">
                        <el-input
                            type="number"
                            :min="1"
                            style="width: 170px;"
                            :placeholder="$t('Member.Desc.fill_fee')"
                            v-model.number="form.fee">
                        </el-input>
                         {{ $t('Reception.Fifth.yuan') }}
                    </el-form-item>
                    <el-form-item :label="$t('Member.Desc.fee_store')">
                        <el-select
                            v-model="form.feeStoreId"
                            style="width: 205px;"
                            :placeholder="$t('Common.store_placeholder')">
                            <el-option
                                v-for="(item, index) in stores"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 身份证号：prop="certNum" -->
                    <el-form-item
                        :label="$t('Sell.identity_number')"
                        class="fitness-redItem">
                        <el-input
                            type="text"
                            v-model="form.certNum"
                            :placeholder="$t('Fill.identity_number_placeholder')"/>
                    </el-form-item>
                    <el-form-item :label="$t('Common.remark')">
                        <el-input
                            type="textarea"
                            v-model="form.remark"
                            :placeholder="$t('Fill.fill_remark')">
                        </el-input>
                    </el-form-item>
            </el-form>
            <div class="text-center mt-10 mb-10">
                <el-button @click="onSubmit" type="primary">{{ $t('Common.next_step') }}</el-button>
            </div>
            <div class="transfer-shop-line"></div>
            <div style="font-size: 12px;" class="flex items-center mt-10">
                <div class="mr-10">{{ $t('Client.tip') }}</div>
                <div>
                    <div>{{ $t('Client.tip1') }}</div>
                    <div class="mt-5">{{ $t('Client.tip2') }}</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
    Autocomplete,
} from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
        ElAutocomplete: Autocomplete,
    },
    data() {
        return {
            visible: false,
            client: {},
            form: {
                contractNums: [],
                storeId: null,
                fee: null,
                feeStoreId: null,
                remark: null,
                certNum: null,
            },
            rules: {
                fee: { required: true, message: this.$t('Fill.fee') },
                certNum: { required: true, message: this.$t('Fill.identity_number_placeholder') },
            },
            stores: [],
            checkAll: false,
            isIndeterminate: false,
            contracts: [],
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
            this.form = {
                contractNums: [],
                storeId: null,
                fee: null,
                feeStoreId: null,
                remark: null,
                certNum: null,
            };
            this.isIndeterminate = false;
            this.checkAll = false;
        },
        open(client) {
            this.resetForm();
            this.visible = true;
            this.fetchClient(client.id);
            this.fetchContract(client.id);
            this.fetchStore();
        },
        fetchClient(id) {
            API.get(`client/${id}/init-contract`, {
                params: {
                    type: 2,
                },
            }).then(res => {
                this.client = res;
                if (res.certNum) this.form.certNum = res.certNum;
            });
        },
        fetchContract(id) {
            API.get(`client/${id}/transfer-store`).then(res => {
                this.contracts = res;
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
                this.form.storeId = res[0].id;
                this.form.feeStoreId = res[0].id;
            });
        },
        handleCheckAllChange(val) {
            this.form.contractNums = val ? this.contracts.map(el => el.contractNum) : [];
            this.isIndeterminate = false;
        },
        handleCheckedContractChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.contracts.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.contracts.length;
        },
        onSubmit() {
            if (!this.form.contractNums.length) return $ele.$message(this.$t('Choose.transfer_contract'));
            this.$refs.form.validate(valid => {
                if (!valid) return false;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            API.post(`client/${this.client.clientId}/transfer-store`, form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.$emit('fetchData');
                    this.visible = false;
                });
        },
    },
};
</script>

<style lang="scss">
.transfer-shop-dialog {
    .el-dialog {
        background: #fff;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
        width: 600px;
        max-height: 850px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-dialog__body {
        max-height: 750px;
        overflow-y: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .el-checkbox {
        margin-right: 20px;
        margin-left: 0px;
    }
    .transfer-shop-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        background: #f7f7f7 !important;
        margin-bottom: 15px;
        padding: 6px 14px;
    }
    .transfer-shop-title-p {
        width: 100% !important;
        font-size: 12px;
        margin: 10px 0;
    }
    .transfer-shop-checkbox {
        .el-form-item__label {
            width: 100% !important;
            text-align: left;
        }
        .el-form-item__content {
            margin-left: 0 !important;
        }
    }
    .transfer-shop-line {
        height: 1px;
        background: #e6e6e6;
        margin: 10px 0;
    }
}
</style>
